/**
 * A boolean written into a URL.
 *
 * Query strings carry text, so `?legacy=1` arrives as the STRING `'1'` — which
 * is why a check for `true || 'true'` let the documented escape hatch silently
 * do nothing. The forms people actually type are all accepted: `?legacy=1`,
 * `?legacy=true`, `?legacy=yes`, and the bare `?legacy`, which arrives empty.
 *
 * Anything else is false, and that matters as much as the truthy list: `?flag=0`
 * and `?flag=false` are people turning something OFF, and a plain "is it
 * present?" test would read both as on.
 */
const TRUTHY = new Set(['1', 'true', 'yes', 'on', '']);

export function searchFlag(value: unknown): boolean {
  if (value === true) return true;
  if (typeof value !== 'string') return false;
  return TRUTHY.has(value.trim().toLowerCase());
}
